import { action as addToCartAction } from "./actions/tbsp-button-add-to-cart";
import { component } from "picoapp";

const buttonActions = {
  "add-to-cart": addToCartAction,
};

export const button = component((node: HTMLButtonElement, ctx) => {
  const action = node.dataset.tbspAction;

  if (typeof action === "undefined" || !(action in buttonActions)) {
    return;
  }

  const clickHandler = (e) => buttonActions[action](e, ctx);

  node.addEventListener("click", clickHandler);

  return (node: HTMLButtonElement) => {
    node.removeEventListener("click", clickHandler);
  };
});
